<template>
  <div>
    <p class="download-success-view__content-text">
      {{ $t('loginAccountSuccess.open-file') }}
    </p>
    <i18n path="loginAccountSuccess.download-link">
      <a
        place="download_link"
        class="simple-link"
        data-testid="download-link"
        aria-label="Download Link"
        @click.prevent="onClickAction('click')"
      >
        {{ $t('loginAccountSuccess.here') }}
      </a>
    </i18n>
    <p
      class="download-success-view__content-text"
      v-html="$t('loginAccountSuccess.help-link')"
    />
    <i18n
      v-if="isOldUser"
      path="loginAccountSuccess.looking-for-v2"
    >
      <a
        place="download_link"
        class="simple-link"
        data-testid="v2-download-link"
        aria-label="V2 Download Link"
        @click.prevent="onClickAction('click', true)"
      >
        {{ $t('loginAccountSuccess.here') }}
      </a>
    </i18n>
    <p class="download-success-view__mac-download-link">
      <i18n
        path="loginAccountSuccess.mac-download"
      >
        <a
          place="download_link"
          class="simple-link"
          data-testid="mac-download-link"
          aria-label="Mac Download Link"
          @click.prevent="downloadMac"
        >
          {{ $t('loginAccountSuccess.here') }}
        </a>
      </i18n>
    </p>
  </div>
</template>

<script>
export default {
    props: {
        userCreationDate: {
            type: String,
            default: '',
        },
        action: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isOldUser: null,
        };
    },
    mounted: function() {
        this.isOldUser = this.shouldSeeV2Download();
    },
    methods: {
        downloadMac() {
            this.$emit('crossOsDownload', 'macOS');
        },
        onClickAction(type, v2Forced) {
            this.$emit('onDownloadStart', type, v2Forced);
        },
        shouldSeeV2Download() {
            if (this.userCreationDate === '') {
                return false;
            }

            return Date.parse('2024-04-23') > Date.parse(this.userCreationDate);
        },
    },
};
</script>

<style src="./DownloadWindowsComponent.scss" lang="scss"></style>